export default function CopyIcon() {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 7V16C19 17.1046 18.1046 18 17 18V19C19 19 20 17.5 20 16V7C20 4.79086 18.2091 3 16 3H10C7.79087 3 6.35001 4.5 6.35001 6H7.50001C7.50001 5 8.34315 4 10 4H16C17.6569 4 19 5.34315 19 7Z"
          fill="white"
        />
        <rect x="4.5" y="5.5" width="13" height="15" rx="3.5" stroke="white" />
      </svg>
    </>
  );
}
